import {
  Component, Input, OnInit,
} from '@angular/core';

import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

const SAMPLE_RATE = 100;
const DD_SITE = 'datadoghq.eu';

@Component({
  selector: 'lib-datadog',
  template: '',
})
export class DatadogComponent implements OnInit {
  @Input() withRum: boolean = false;

  @Input() withLogs: boolean = false;

  @Input() applicationId: string = '';

  @Input() clientToken: string = '';

  @Input() service: string = '';

  @Input() env: string = '';

  @Input() version: string = '';

  ngOnInit() {
    if (this.withRum) {
      datadogRum.init({
        applicationId: this.applicationId,
        clientToken: this.clientToken,
        site: DD_SITE,
        service: this.service,
        env: this.env,
        sampleRate: SAMPLE_RATE,
        premiumSampleRate: 0,
        version: this.version,
        trackInteractions: true,
        allowedTracingOrigins: [/https:\/\/api(-staging)?\.proportunity\.com/]
      });
    }
    if (this.withLogs) {
      datadogLogs.init({
        clientToken: this.clientToken,
        site: DD_SITE,
        service: this.service,
        env: this.env,
        version: this.version,
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ['error'],
        sampleRate: SAMPLE_RATE,
      });
    }
  }
}
